import React, { Fragment, useContext, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
  makeStyles,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import { FhirReferralsAPI, ReferralUtils } from "../../../services";
import { EmbeddedForm } from "../Forms/EmbeddedForm";
import { referralsFormRendererUrl, referralsFormUUID } from "../../../utils/constants";
import { getIdFromReference } from "./utils";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    // minWidth: 500,
  },
  checkBox: {
    margin: theme.spacing(1),
    marginBottom: 0,
  },
  right: {
    marginLeft: "auto",
  },
  cancelButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: "auto",
  },
  searchButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: "auto",
  },
}));

const API = FhirReferralsAPI;

const FhirReferralAddForm = ({
  open,
  handleClose,
  handleSave,
  submitError,
  setSubmitError,
  planDefinition,
  requestIntentVS,
  requestCategoryVS,
  referralServicesInternal,
  referralPathCategory,
  healthcareServices,
  advancedPlanDefinitionIds,
  instantiatesCanonical,
  setInstantiatesCanonical,
}) => {
  const classes = useStyles();

  const [intent, setIntent] = useState(null);
  const [serviceTypeItem, setServiceTypeItem] = useState(null);

  const [formLoaded, setFormLoaded] = useState(false);


  const [isAdvanced, setIsAdvanced] = useState(false);

  const planDefinitionInternal =
    instantiatesCanonical?.planDefinitionType?.includes("internal") ?? null;

  const isFormDataValid = () => {
    if (isAdvanced) {
      if (instantiatesCanonical) {
        return true
      }
    }
    else if (instantiatesCanonical && intent && serviceTypeItem) {
      return true;
    }

    return false;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!isFormDataValid()) {
      return;
    }

    const referralPayload = {
      instantiatesCanonical: instantiatesCanonical,
      ...(!isAdvanced && { intent: intent }),
      ...(!isAdvanced && { service: serviceTypeItem }),
    };

    handleSave(referralPayload);
    onClose();
  };

  const handlePlanDefinitionChange = () => {
    console.log("DEBUG handlePlanDefinitionChange advancedPlanDefinitionIds: ", advancedPlanDefinitionIds);
    console.log("DEBUG handlePlanDefinitionChange instantiatesCanonical: ", instantiatesCanonical);
    if (instantiatesCanonical && instantiatesCanonical?.reference) {
      const canonicalId = getIdFromReference(instantiatesCanonical?.reference)
      console.log("DEBUG handlePlanDefinitionChange canonicalId: ", canonicalId);
      if (advancedPlanDefinitionIds.includes(canonicalId)) {
        setIsAdvanced(true);
        return;
      } else {
        setIsAdvanced(false);
      }
    } else {
      setIsAdvanced(false);
    }
  };


  useEffect(() => {
    handlePlanDefinitionChange();
  }, [instantiatesCanonical]);

  const onClose = () => {
    setInstantiatesCanonical(null);
    setIntent(null);
    setServiceTypeItem(null);
    handleClose();
  };

  const handleFormLoaded = (preventionLinkIframe) => {
    console.log("DEBUG handleFormLoaded");
    ReferralUtils.setPreventionLinkIframe(preventionLinkIframe);
    setFormLoaded(true);
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={isAdvanced ? "xl" : "md"}
        // style={{
        //   width: "80%",
        // }}
        open={open}
        onClose={onClose}
        aria-labelledby="fhir-referral-add-form"
        scroll="paper"
      >
        <DialogTitle id="fhir-referral-add-form-title">
          Add New Referral
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            {!isAdvanced ? (
              <FormGroup row>
                <Autocomplete
                  freeSolo
                  options={requestIntentVS}
                  getOptionLabel={({ code }) => code}
                  variant="outlined"
                  margin="dense"
                  label="Intent"
                  fullWidth
                  value={intent}
                  onChange={(_, intent) => {
                    setIntent(intent);
                  }}
                  // inputValue={serviceTypeSearch}
                  // onInputChange={handleServiceTypeSearchChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Intent" />
                  )}
                />
              </FormGroup>
            ) : null}



            <FormGroup row>
              <Autocomplete
                freeSolo
                options={planDefinition}
                getOptionLabel={({ title }) => title}
                variant="outlined"
                margin="dense"
                label="Plan Definition"
                fullWidth
                value={instantiatesCanonical}
                onChange={(_, instantiatesCanonical) => {
                  setInstantiatesCanonical(instantiatesCanonical);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Plan Definition" />
                )}
              />
            </FormGroup>

            {!isAdvanced ? (
              <FormGroup row>
                <Autocomplete
                  freeSolo
                  options={
                    planDefinitionInternal
                      ? referralServicesInternal?.map((e) => ({
                        label: e?.display || "",
                        value: {
                          healthcareService: {
                            coding: [{ ...e }],
                            text: e?.display,
                          },
                          organization: undefined,
                        },
                      })) ?? []
                      : healthcareServices
                  }
                  onChange={(_, serviceTypeItem) => {
                    setServiceTypeItem(serviceTypeItem);
                  }}
                  getOptionLabel={({ label }) => label}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  variant="outlined"
                  margin="dense"
                  label="Service"
                  fullWidth
                  value={serviceTypeItem}
                  renderInput={(params) => (
                    <TextField {...params} label="Service" />
                  )}
                />
              </FormGroup>
            ) : null}

            <FormGroup row>
              {!isAdvanced ? (
                <Button
                  color="primary"
                  type="submit"
                  // disabled={isSearching}
                  className={classes.searchButton}
                >
                  Save
                </Button>
              ) : null}
            </FormGroup>
          </form>

          {isAdvanced ? (
            <EmbeddedForm
              // formUUID={formUUID}
              formUUID={referralsFormUUID}
              formRendererUrl={referralsFormRendererUrl}
              // size={{ ...size, height: "530px" }}
              size={{ width: "800px", height: "530px" }}
              formParameters={{}}
              onFormLoaded={handleFormLoaded}
              submitError={submitError}
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            className={classes.cancelButton}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

FhirReferralAddForm.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default FhirReferralAddForm;
